import React, { useState, useEffect } from "react";
import "../../Components/Navigation/Navigation.css";
import Logo from "../../Assets/Images/homepage_logo.svg";

const Navigation = ({ linkColor = "white", submenuColor = "black", menuIconColor = "white" }) => {
  const [isMenuActive, setMenuActive] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuActive(!isMenuActive);
  };

  const handleSubMenuClick = (index) => {
    if (isMobile) {
      setActiveSubMenu((prevIndex) => (prevIndex === index ? null : index));
    }
  };

  return (
    <div className="NavContainer">
      <header>
        <div className="headerContainer">
          <nav className={isMenuActive ? "active" : ""}>
            <div className="menu-icons" onClick={toggleMenu} style={{ color: menuIconColor }}>
              <i className={`fas ${isMenuActive ? "fa-times" : "fa-bars"}`}></i>
            </div>
            <a href="/" className="logo">
              <img src={Logo} alt="Logo" />
            </a>
            <ul className={`nav-list ${isMenuActive ? "mobile-active" : ""}`}>
              <li><a href="/" className="main-nav-link" style={{ color: linkColor }}>Home</a></li>

              <li className={`nav-item ${activeSubMenu === 1 ? "active" : ""}`}>
                <a href="#" onClick={() => handleSubMenuClick(1)} className="main-nav-link" style={{ color: linkColor }}>
                  About Us <i className="fas fa-caret-down"></i>
                </a>
                <ul className={`sub-menu ${isMobile && activeSubMenu === 1 ? "open" : ""}`}>
                  <li><a href="/meet-the-team" className="submenu-link" style={{ color: submenuColor }}>Meet The Team</a></li>
                  <li><a href="/about-the-company" className="submenu-link" style={{ color: submenuColor }}>About The Company</a></li>
                </ul>
              </li>

              <li className={`nav-item ${activeSubMenu === 2 ? "active" : ""}`}>
                <a href="#" onClick={() => handleSubMenuClick(2)} className="main-nav-link" style={{ color: linkColor }}>
                  Lettings <i className="fas fa-caret-down"></i>
                </a>
                <ul className={`sub-menu ${isMobile && activeSubMenu === 2 ? "open" : ""}`}>
                  <li><a href="/process-with-lettings" className="submenu-link" style={{ color: submenuColor }}>Process</a></li>
                  <li><a href="/lettings" className="submenu-link" style={{ color: submenuColor }}>Available to let</a></li>
                  <li><a href="/register-with-us" className="submenu-link" style={{ color: submenuColor }}>Register</a></li>
                </ul>
              </li>

              <li className={`nav-item ${activeSubMenu === 3 ? "active" : ""}`}>
                <a href="#" onClick={() => handleSubMenuClick(3)} className="main-nav-link" style={{ color: linkColor }}>
                  Sales <i className="fas fa-caret-down"></i>
                </a>
                <ul className={`sub-menu ${isMobile && activeSubMenu === 3 ? "open" : ""}`}>
                  <li><a href="/process-with-sales" className="submenu-link" style={{ color: submenuColor }}>Process</a></li>
                  <li><a href="/sales" className="submenu-link" style={{ color: submenuColor }}>Available for sales</a></li>
                  <li><a href="/register-with-us" className="submenu-link" style={{ color: submenuColor }}>Register</a></li>
                </ul>
              </li>

              <li><a href="/additional-services" className="main-nav-link" style={{ color: linkColor }}>Additional Services</a></li>
              <li><a href="/testimonials" className="main-nav-link" style={{ color: linkColor }}>Testimonials</a></li>
              <li><a href="/contact-us" className="main-nav-link" style={{ color: linkColor }}>Contact Us</a></li>
              <li className="valBtn">
                <a href="/book-valuation" style={{ color: linkColor }}>Request Valuation</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Navigation;
